// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionStyles } from "@adl/Overrides/Widgets/MyListsDetails/MyListsDetailsActions";
import Close from "@adl/XDL/Icons/Close";
import Print from "@adl/XDL/Icons/Print";
import Quote from "@adl/XDL/Icons/Quote";
import Remove from "@adl/XDL/Icons/Remove";
import { color } from "@adl/XDL/Utilities";
import { generateButtonLinkStyle, pageTitleStyle } from "@adl/XDL/Utilities/sharedStyles";
import Calendar from "@insite/mobius/Icons/Calendar";
import Copy from "@insite/mobius/Icons/Copy";
import Download from "@insite/mobius/Icons/Download";
import Edit from "@insite/mobius/Icons/Edit";
import Share from "@insite/mobius/Icons/Share";
import Slash from "@insite/mobius/Icons/Slash";
import Tag from "@insite/mobius/Icons/Tag";
import { css } from "styled-components";

actionStyles.nameText = pageTitleStyle;

actionStyles.printButton = generateButtonLinkStyle(Print);

actionStyles.removeSelectedButton = generateButtonLinkStyle(Close);

actionStyles.shareButton = generateButtonLinkStyle(Share);

actionStyles.editButton = generateButtonLinkStyle(Edit);

actionStyles.scheduleButton = generateButtonLinkStyle(Calendar);

actionStyles.createQuoteButton = generateButtonLinkStyle(Quote);

actionStyles.addTagsButton = generateButtonLinkStyle(Tag);

actionStyles.copyButton = generateButtonLinkStyle(Copy);

actionStyles.hideButton = generateButtonLinkStyle(Slash);

actionStyles.exportButton = generateButtonLinkStyle(Download);

actionStyles.deleteButton = generateButtonLinkStyle(Remove);

actionStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            order: 1;
            margin-left: 5px;
        `,
    },
};

actionStyles.buttonWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-start;
        white-space: nowrap;
    `,
};

actionStyles.addListButton = {
    css: css`
        margin-left: 5px;
        padding: 0 15px;
    `,
};

actionStyles.copyListModal = {
    sizeVariant: "small",
};

actionStyles.starXIcon = {
    ...actionStyles.starXIcon,
    css: css`
        &&& svg path {
            fill: ${color("text.link")};
        }
    `,
};

actionStyles.starIcon = {
    ...actionStyles.starIcon,
    css: css`
        &&& svg path {
            fill: ${color("text.link")};
        }
    `,
};

actionStyles.iconContainer = {
    css: css`
        width: 15px;
        margin-top: 12px;
        margin-right: 12px;
    `,
};
